import { Link, useLocation } from "react-router-dom";
import { Leaf, BookOpen, Plus, LogOut, Library } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../lib/auth";

export const Header = () => {
  const location = useLocation();
  const onBuilder = location.pathname.startsWith("/recettes/");
  const { user, logout } = useAuth();

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-stone-50/80 border-b border-stone-200 h-16 flex items-center justify-between px-6 sm:px-12"
    >
      <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
        <span className="h-9 w-9 rounded-xl bg-emerald-700 text-white grid place-items-center transition-transform group-hover:rotate-6">
          <Leaf className="h-5 w-5" />
        </span>
        <span className="font-heading text-xl font-extrabold tracking-tight text-stone-900">
          NutriCal
        </span>
        <span className="ml-2 text-[10px] tracking-[0.2em] uppercase font-semibold text-stone-400 hidden sm:inline">
          BLV · USDA
        </span>
      </Link>

      <nav className="flex items-center gap-2">
        <Link to="/" data-testid="nav-recipes-link">
          <Button
            variant="ghost"
            className="text-stone-700 hover:text-emerald-700 hover:bg-emerald-50 font-semibold"
          >
            <BookOpen className="h-4 w-4 mr-2" />
            Mes recettes
          </Button>
        </Link>
        <Link to="/bibliotheque" data-testid="nav-library-link">
          <Button
            variant="ghost"
            className="text-stone-700 hover:text-emerald-700 hover:bg-emerald-50 font-semibold"
          >
            <Library className="h-4 w-4 mr-2" />
            Bibliothèque
          </Button>
        </Link>
        {!onBuilder && (
          <Link to="/recettes/nouvelle" data-testid="nav-new-recipe-link">
            <Button className="bg-emerald-700 hover:bg-emerald-800 text-white font-semibold tracking-wide rounded-lg">
              <Plus className="h-4 w-4 mr-2" />
              Nouvelle recette
            </Button>
          </Link>
        )}
        {user && (
          <div className="flex items-center gap-2 ml-2 pl-3 border-l border-stone-200">
            <span className="hidden md:inline text-xs text-stone-500 truncate max-w-[180px]" title={user.email}>
              {user.email}
            </span>
            <Button
              variant="ghost"
              size="icon"
              onClick={logout}
              className="text-stone-500 hover:text-red-600 hover:bg-red-50 h-9 w-9"
              data-testid="logout-btn"
              title="Se déconnecter"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;

